export let roleA = [8, '8'];

export let roleC = [5, '5'];

export let rolea = [10, '10'];

export let roleAIai = [...roleA, ...rolea, 11, 12, '11', '12'];

export let roleai = [...rolea, 11, '11'];

export let roleAI = [...roleA, 12, '12'];

export let roleAC = [...roleA, ...roleC];

export let roleCK = [4, '4', ...roleC];

export let roleAICK = [...roleAI, ...roleCK];

export let roleuc = [6, '6', 7, '7'];

export let roleaiuc = [...roleai, ...roleuc];


// WEBPACK FOOTER //
// ./src/js/roles.js